<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-sm-12 ">
        <div class="x_panel">
          <h2 v-if="listMode" class="float-left">Breakdown History Maintenance List  </h2>
          <h2 v-if="!listMode" class="float-left">Job Done  </h2>
          <ul class="nav navbar-right panel_toolbox">
            <li v-if="!listMode">
              <button type="button" class="btn btn-info btn-sm" @click="changeListMode">View Job List <i class="fa fa-eye"></i></button>
            </li>
            <li v-if="listMode">
              <button v-if="listMode && isPermissionExist(PERMISSIONS.BREAKDOWN_HISTORY_REPORT_PRINT)" @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                <i class="fa fa-print" v-if="!isPrinting"></i>
                <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                {{ isPrinting ? 'Printing...' : 'Print' }}
              </button>
            </li>
            <li v-if="listMode">
              <vue-excel-xlsx
                v-if="listMode && isPermissionExist(PERMISSIONS.BREAKDOWN_HISTORY_REPORT_PRINT)"
                ref="excel"
                :data="excelData"
                :columns="excelHeader"
                :file-name="'Breakdown History Maintenance List'"
                :file-type="'xlsx'"
                :sheet-name="'sheetname'"
                :disabled="isPrinting"
                class="btn btn-primary btn-sm float-right"
              >
                <div
                  @click.prevent="handleExportPrint('excel')"
                >
                  <i class="fa fa-file-excel-o"></i>
                  {{ isPrinting ? 'Preparing...' : 'Excel' }}
                </div>
              </vue-excel-xlsx>
            </li>
            <li v-if="listMode">
              <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
            </li>
          </ul>
        </div>

        <div class="">
          <div class="x_content ">
            <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
              <PulseLoader :loading="loading"></PulseLoader>
            </div>
            <div class="row" v-if="listMode && jobList && !loading">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-2">
                        <div class="form-group">
                          <label>Vessel</label>
                          <select class="form-control" v-model="scheduleInfo.vesselId">
                            <option value="" selected>Select Vessel</option>
                            <option v-for="(row, key) in vessels" :value="row?.id">{{row?.name}}</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-3 col-6">
                        <div class="form-group">
                          <label>Date From</label>
                          <DatePicker type="date" placeholder="Date From" v-model="scheduleInfo.dateFrom" valueType="format"></DatePicker>
                        </div>
                      </div>
                      <div class="col-md-3 col-6">
                        <div class="form-group">
                          <label>Date To</label>
                          <DatePicker type="date" placeholder="Date To" v-model="scheduleInfo.dateTo" valueType="format"></DatePicker>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="form-group">
                          <label>Critical Jobs</label>
                          <select class="form-control" v-model="scheduleInfo.critical_jobs">
                            <option value>Select Critical Jobs</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="form-group">
                          <label>Critical Components</label>
                          <select class="form-control" v-model="scheduleInfo.critical_component">
                            <option value>Select Critical Components</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-2 col-6">
                        <div class="form-group">
                          <label for="">Search </label>
                          <input type="text" v-model="scheduleInfo.searchInput" placeholder="Enter Job, Component Name and Code" name="searchInput" class="form-control">
                        </div>
                      </div>
                      <div class="col-md-2 mt-2 ">
                        <div class="form-group">
                          <label for=""></label>
                          <button class="form-control btn-info btn btn-sm" @click="getAllJobList()">Search</button>
                        </div>
                      </div>
                    </div>

                    <PerPageSelector v-model="offset" @change="onPerPageChange"/>
                    <div class="card-box table-responsive">
                      <TableData :jobList="jobList?.data"
                                 :jobDoneFunction="jobDoneFunction"
                                 :currentPage="Number(jobList?.current_page)"
                                 :perPage="Number(jobList?.per_page)"
                      />
                      <Pagination :pagination="jobList" :getData="getAllJobList"/>

                      <div id="printArea" style="display: none">
                        <div style="text-align: center;line-height: 20px;">
                          <h2 style="line-height: 10px;">{{ appName }}</h2>
                          <div style="line-height: 10px;" class="font-weight-bold">Breakdown History List</div>
                          <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                        </div>
                        <TableData :jobList="printItems" :isPrinting="true"/>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <JobDone v-if="JobDoneStatus" :jobInfo="selectedJob" :mode="permitWorkMode" :componentName="componentName" :Schedule="scheduleData" @enableListMode="changeListMode"/>
  </div>
</template>

<script>

    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import Tree from 'vuejs-tree'
    import {VueEditor} from 'vue2-editor'
    import RiskAssessment from "@/components/Maintenance/RiskAssessment.vue";
    import PermitToWork from "@/components/Maintenance/PermitToWork.vue";
    import DeferReschedule from "@/components/Maintenance/DeferReschedule.vue";
    import auth from '../../../auth'
    import JobDone from '../JobDone.vue'
    import TableData from "./TableData.vue";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import exportMixin from "@/mixin/exportMixin";
    import {apiPrintData} from "@/utils/print";
    import permissionsMixin from "@/mixin/permissionsMixin";

    export default {
        mixins: [printMixin, goBackButtonMixin, exportMixin, permissionsMixin],
        name: 'breakdown-report',
        components: {
            VueEditor,
            RiskAssessment,
            PermitToWork,
            JobDone,
            DeferReschedule,
            Tree,
            DatePicker,
            PulseLoader,
            TableData
        },
        data() {
            return {
                appName: process.env.VUE_APP_NAME,
                loading: false,
                reportList: false,
                color: '#1ABB9C',
                isPrinting: false,
                size: '10px',
                jobId: 25,
                selectedComponent: '',
                selectedJob: Object,
                treeDisplayData: [],
                printItems: [],
                scheduleId: '',
                scheduleData: '',
                componentName: '',
                jobType: '',
                query: '',
                content: '',
                queryFiled: 'name',
                jobRemarks: '',
                listMode: true,
                IRR: false,
                P2W: false,
                JobDoneStatus: false,
                DeferReschedule: false,
                offset: 20,
                editMode: false,
                permitWorkMode: false,
                tableEnableMode: false,
                chiefPermisionMode: false,
                vessels: null,
                departments: [],
                mainComponents: [],
                components: [],
                subcomponents: [],
                subsubcomponents: [],
                jobPrintListData: [],
                jobList: [],
                vessel_id: auth.getVesselId(),
                permissions: auth.getPermissionData(),
                user_type: auth.getUserType(),
                form: new Form({
                    id: '',
                    name: '',
                    email: '',
                    status: 'Activate'
                }),
                pagination: {
                    current_page: 1,
                    offset: 5
                },
                filter: new Form({
                    dateRange: '',
                    jobType: '',
                    jobId: '',
                    vessel_id: auth.getVesselId(),
                }),
                scheduleInfo: new Form({
                    vesselId: auth.getVesselId(),
                    searchInput: '',
                    filterDate: '',
                    dateFrom: '',
                    dateTo: '',
                    critical_jobs: '',
                    critical_component: '',
                    print_enable: false
                }),
                excelHeader: [],
                excelData: []
            }
        },
        mounted() {
            this.getVessel();
            this.getAllJobList();
        },
        methods: {
            getVessel() {
              let params = {
                is_all: 1
              }
              this.$http.get('/api/vessel', {params}).then(response => {
                this.vessels = response.data.success.vessel
              }).catch(e => {
                console.log(e)
              })
            },

            onPerPageChange() {
              this.getAllJobList(1);
            },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Job Name(Code)': `${item?.job_schedules?.job?.name || ''} (${item?.job_schedules?.job?.code || ''})`,
                'Department Name(Code)': `${item?.job_schedules?.job?.department?.name || ''} (${item?.job_schedules?.job?.department?.code || ''})`,
                'Component Name(Code)': `${item?.job_schedules?.job?.component?.name || ''} (${item?.job_schedules?.job?.component?.code || ''})`,
                'Completion Date': `${item?.date || ''}`,
                'Done By': `${item?.done_by_rank?.rank || ''}`,
                'Verified By': `${item?.verified_by_rank?.name || ''}`,
                'Verified By Office': `${item?.status == 'Accept' ? 'Complete' : 'Pending'}`,
              });
            });
            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                vesselId: this.scheduleInfo.vesselId,
                searchInput: this.scheduleInfo.searchInput,
                date_from: this.scheduleInfo.dateFrom,
                date_to: this.scheduleInfo.dateTo,
                critical_jobs: this.scheduleInfo.critical_jobs,
                critical_component: this.scheduleInfo.critical_component,
                is_all: 1,
              };

              const res = await this.$http.get('/api/filter/all-job-breakdown-history-list', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Breakdown History Maintenance List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },

            getAllJobList(page = 1) {
                this.jobList = [];
                this.loading = true;
                let params = {
                    vesselId: this.scheduleInfo.vesselId,
                    searchInput: this.scheduleInfo.searchInput,
                    date_from: this.scheduleInfo.dateFrom,
                    date_to: this.scheduleInfo.dateTo,
                    critical_jobs: this.scheduleInfo.critical_jobs,
                    critical_component: this.scheduleInfo.critical_component,
                    is_all: 0,
                    page: page,
                    offset: this.offset,
                };
                this.$http.get('/api/filter/all-job-breakdown-history-list', {params}).then(response => {
                    this.jobList = response.data.success;
                    this.loading = false
                }).catch(e => {
                    this.loading = false
                    let response = e.response;
                    if (response?.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                });
            },
            jobDoneFunction(job) {
                if (job?.job_done_reports && job?.job_done_reports != null) {
                    this.permitWorkMode = true
                } else {
                    this.permitWorkMode = false
                }
                if (this.user_type <= 3 && job?.job_done_reports == null) {
                    this.$snotify.warning('Job Done Report is not Submitted')
                } else {
                    this.listMode = false
                    this.IRR = false
                    this.P2W = false
                    this.JobDoneStatus = true
                    this.selectedJob = job?.job_schedules?.job
                    this.scheduleData = job?.job_schedules
                    this.componentName = job?.job_schedules?.job?.component?.name
                }

            },
            //this function use for change list mode
            changeListMode() {
                this.IRR = false
                this.P2W = false
                this.JobDoneStatus = false
                this.DeferReschedule = false
                this.listMode = true
                this.getAllJobList()
            }
        }
    }
</script>

<style scoped>
  .mx-datepicker {
    width: 100% !important;
  }

</style>
